<template>
  <div>
    <div class="container">
      <div class="row">
        <div v-if="sectionContent.title || sectionContent.description || sectionContent.secondTitle">
          <title-area :title="sectionContent.title" />
          <p>{{ sectionContent.description }}</p>
          <!-- <h3 class="text-decoration-underline">{{ sectionContent.secondTitle }}</h3> -->
        </div>
      </div> 

      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <vendimet-filters
                ref="filters"
                v-model="filters"
                @apply-filters="handleApplyFilters"
                :documentTypeId="Number(route.query.documentTypeId)"
                @update:availableYears="setAvailableYears"
              />
            </div>
            <div class="row">
              <div class="mb-3">
                <div v-if="loading" class="text-center">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <div v-if="error" class="alert alert-danger">
                  {{ error }}
                  <button class="btn btn-sm btn-primary ms-2" @click="fetchDocuments">Retry</button>
                </div>
              </div>
              <table v-if="!loading && !error" class="table table-sm table-hover table-bordered">
                <thead>
                  <tr>
                    <th colspan="4" class="search-header">
                      <div class="input-group input-group-sm w-25 ms-auto">
                        <input type="text" v-model="searchValue" class="form-control" :placeholder="$t('dokumentet.search_placeholder')" />
                        <span class="input-group-text bg-transparent">
                          <i class="bi bi-search"></i>
                        </span>
                        <button v-if="searchValue" class="btn btn-outline-secondary btn-sm" @click="clearSearch">
                          Clear
                        </button>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col" class="id-column">#</th>
                    <th scope="col" class="date-column">{{this.$t('dokumentet.data')}} </th>
                    <th scope="col" colspan="2">{{this.$t('dokumentet.title')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(doc, index) in paginatedData" :key="doc.Id">
                    <td>{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                    <td>{{ doc.CreatedDate }}</td>
                    <td>{{ doc.Title }}</td>
                    <td class="text-center align-middle">
                      <a v-if="doc.DocumentFileUrl && doc.DocumentFileUrl !== 'No file'" :href="doc.DocumentFileUrl" target="_blank">
                        <font-awesome-icon icon="fa-solid fa-file-pdf" />
                      </a>
                      <span v-else></span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!loading && !error && paginatedData.length === 0" class="alert alert-info">
                No documents found.
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3 pagination-container">
                <nav aria-label="Page navigation" class="pagination-wrapper">
                  <ul class="pagination mb-0">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <button class="page-link" @click="changePage(currentPage - 1)" aria-label="Previous page">
                        <font-awesome-icon icon="fa-solid fa-angle-left" />
                      </button>
                    </li>
                    <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                      <button class="page-link" @click="changePage(page)">{{ page }}</button>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <button class="page-link" @click="changePage(currentPage + 1)" aria-label="Next page">
                        <font-awesome-icon icon="fa-solid fa-angle-right" />
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import TitleArea from '../share/TitleArea.vue';
import { useDocumentStore } from '@/store/DocumentStore/documentStore';
import { useRoute } from 'vue-router';
import VendimetFilters from '../share/VendimetFilters.vue';

export default {
  name: 'VendimetPage',
  data() {
    return {
      documentStore: useDocumentStore(),
      searchValue: '',
      currentPage: 1,
      itemsPerPage: 10,
      headerTitle: '',
      route: useRoute(),
      filters: {
        CategoriesIds: [],
        SubCategoriesIds: [],
        PostCategoriesIds: [],
        selectYear: new Date().getFullYear(), // Initialize with current year
      },
      availableYears: [],
    };
  },
  components: {
    TitleArea,
    VendimetFilters,
  },
  computed: {
    sectionContent() {
      const contentMap = {
        51: {
          title: this.$t('sistemi_prokurorial.page.performance.title'),
          description: this.$t('sistemi_prokurorial.page.performance.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.performance.secondTitle'),
        },
        40: {
          title: this.headerTitle,
          description: this.$t('sistemi_prokurorial.page.disciplining.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.disciplining.secondTitle'),
        },
        52: {
          title: this.$t('sistemi_prokurorial.page.disciplining.diciplining_decisions.title'),
          description: this.$t('sistemi_prokurorial.page.disciplining.diciplining_decisions.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.disciplining.secondTitle'),
        },
        48: {
          title: 'Raportet',
          description: this.$t('sistemi_prokurorial.page.disciplining.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.disciplining.secondTitle'),
          
        },
        1195: {
          title: this.$t('sistemi_prokurorial.page.disciplining.reports.title'),
          description: this.$t('sistemi_prokurorial.page.disciplining.reports.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.disciplining.secondTitle'),
          
        },
        42: {
          title: this.$t('sistemi_prokurorial.page.professional_ethics.title'),
          description: this.$t('sistemi_prokurorial.page.professional_ethics.description'),
          secondTitle: this.$t('sistemi_prokurorial.page.professional_ethics.secondTitle'),
        },
      };
      return contentMap[this.route.query.documentTypeId] || {};
    },
    filteredDocuments() {
      if (!this.searchValue) return this.documentStore.documentet;
      const searchTerm = this.searchValue.toLowerCase();
      return this.documentStore.documentet.filter(
        (doc) =>
          doc.Title?.toLowerCase().includes(searchTerm) ||
          doc.Language?.toLowerCase().includes(searchTerm)
      );
    },
    totalPages() {
      return Math.ceil(this.filteredDocuments.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredDocuments.slice(start, end);
    },
    loading() {
      return this.documentStore.loading;
    },
    error() {
      return this.documentStore.error;
    },
  },
  watch: {
    'route.query': {
      handler(newQuery) {
        this.headerTitle = newQuery.title || this.$t('sistemi_prokurorial.menu.disciplining.title');
        this.fetchDocuments();
      },
      deep: true,
      immediate: true,
    },
    searchValue() {
      this.debouncedSearch();
    },
  },
  methods: {
    debouncedSearch: debounce(function () {
      this.currentPage = 1;
    }, 300),
    setAvailableYears(years) {
      this.availableYears = years;
    },
    async fetchDocuments() {
      let dateRange = null;
      if (this.filters.selectYear === '') {
        // "Të gjitha" selected: use min/max year from availableYears
        if (this.availableYears.length > 0) {
          const minYear = Math.min(...this.availableYears);
          const maxYear = Math.max(...this.availableYears);
          dateRange = {
            startDate: new Date(minYear, 0, 1),
            endDate: new Date(maxYear, 11, 31),
          };
        }
      } else if (this.filters.selectYear) {
        dateRange = {
          startDate: new Date(this.filters.selectYear, 0, 1),
          endDate: new Date(this.filters.selectYear, 11, 31),
        };
      }
      const prokuroriaId = this.route.query.prokuroriaId
        ? Number(this.route.query.prokuroriaId)
        : null;
      const documentTypeId = this.route.query.documentTypeId
        ? Number(this.route.query.documentTypeId)
        : null;

      if (prokuroriaId !== null && isNaN(prokuroriaId)) {
        console.warn('Invalid prokuroriaId:', this.route.query.prokuroriaId);
        return;
      }
      if (documentTypeId !== null && isNaN(documentTypeId)) {
        console.warn('Invalid documentTypeId:', this.route.query.documentTypeId);
        return;
      }

      const params = {
        prokuroriaId,
        documentTypeId,
        CategoriesIds: this.filters.CategoriesIds,
        SubCategoriesIds: this.filters.SubCategoriesIds,
        PostCategoriesIds: this.filters.PostCategoriesIds,
        dateRange,
      };

      console.log('Fetching documents with params:', params);
      await this.documentStore.getDocumentet(params);
    },
    handleApplyFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.fetchDocuments();
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    clearSearch() {
      this.searchValue = '';
      this.currentPage = 1;
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
    },
  },
};
</script>

<style scoped>
/* Existing styles remain unchanged */
.search-header {
  background-color: #f8f9fa;
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
}

.id-column {
  width: 50px;
  min-width: 50px;
}

.date-column {
  width: 50px;
  min-width: 50px;
}

.title-column {
  width: 150px;
  min-width: 150px;
}

@media (max-width: 576px) {
  .input-group {
    width: 100% !important;
  }
}

.card {
  background: #EFF2F5 !important;
  margin: 0;
  border: transparent !important;
  border-radius: 12px !important;
}

.card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.input-group {
  max-width: 300px;
}

.input-group .form-control {
  background-color: transparent;
  box-shadow: none;
}

.input-group .form-control:focus {
  border-color: #ced4da;
  box-shadow: none;
}

.input-group-text {
  background-color: transparent;
}

.table th,
.table td {
  vertical-align: middle;
  padding: 8px;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f9fa;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.pagination {
  margin-top: 20px;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.pagination-container {
  gap: 15px;
}

.pagination-wrapper {
  flex: 1;
  max-width: 40%;
}

.pagination {
  margin-bottom: 0;
  flex-wrap: nowrap;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

p {
  color: #101826;
  font-size: 16px;
}

h3 {
  color: #101826;
}
</style>